import {gql} from 'apollo-angular';
import {baseResponse, baseResponseGraphqlField,} from 'src/app/store/base.graphql';

export const uploadableFormFields = `
id
formUniqueId
formService {
  id
  serviceUniqueId
  serviceName
  serviceDescription
}
formName
formDescription
formIsPublished
formApiDoc
formApiDetails {
  id
  formApiUniqueId
  formApiUrl
  formApiDescription
  formRequiresAuth
  formApiAuthType
  formApiKey
  formJwtToken
  formClientId
  formClientSecret
}
`;

export const CREATE_SERVICE_UPLOADABLE_FORM = gql`
  mutation CreateServiceUploadableFormMutation($input: ServiceUploadableFormInputObject!) {
    createServiceUploadableFormMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${uploadableFormFields}
      }
    }
  }
`;

export const UPDATE_UPLOADABLE_FORM = gql`
  mutation UpdateServiceUploadableFormMutation($input: ServiceUploadableFormInputObject!) {
    updateServiceUploadableFormMutation(input: $input) {
      data{
        ${uploadableFormFields}
      }
      response{
        ${baseResponse}
      }
    }
  }
`;

export const GET_ALL_UPLOADABLE_FORMS = gql`
  query GetServiceUploadableForm($filtering: ServiceUploadableFormFiltering) {
    getServiceUploadableForm(filtering: $filtering) {
      ${baseResponseGraphqlField}
      data {
        ${uploadableFormFields}
      }
    }
  }
`;

export const DELETE_UPLOADABLE_FORM = gql`
  mutation DeleteServiceUploadableFormMutation($formUniqueId: String!) {
    deleteServiceUploadableFormMutation(formUniqueId: $formUniqueId) {
      ${baseResponseGraphqlField}
    }
  }
`;
// CITIZEN
export const CITIZEN_GET_SERVICE_UPLOADABLE_FORM = gql`
  query CitizenGetServiceUploadableForm($serviceUniqueId: String) {
    citizenGetServiceUploadableForm(serviceUniqueId: $serviceUniqueId) {
      data{
        ${uploadableFormFields}
      }
      response{
        ${baseResponse}
      }
    }
  }
`;

export const CREATE_UPLOADABLE_FORM_API_DETAIL = gql`
  mutation CreateServiceUploadableFormServerConfigsMutation($input: ServiceUploadableFormServerConfigInputObject!) {
    createServiceUploadableFormServerConfigsMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        id
        formApiUniqueId
        formApiUrl
        formApiDescription
        formRequiresAuth
        formApiAuthType
        formApiKey
        formJwtToken
        formClientId
        formClientSecret
      }
    }
  }`;

export const PUBLISH_UPLOADABLE_FORM = gql`
  mutation PublishUploadableFormMutation($input: UploadableFormPublishInputObjects!) {
    publishUploadableFormMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${uploadableFormFields}
      }
    }
  }
`
